//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import regionSeatLibs from "utils/regionSeatLibs";
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));
import { uploadImg } from "@/api/uploadImg";

export default {
  components: {},
  props: [],
  data() {
    const valiMobilePass = (rule, value, callback) => {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的登录手机号"));
      } else {
        callback();
      }
    };
    const validateIdCard = (rule, value, callback) => {
      if (value && value.length != 18) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value && !reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    var validatorYyeqixian = (rule, value, callback, source) => {
      if (!this.form.businessTerm) {
        callback(new Error("营业期限不能为空"));
      } else {
        callback();
      }
    };
    var vallidLogo = (rule, value, callback, source) => {
      if (!this.logoFileList) {
        callback(new Error("企业logo不能为空"));
      } else {
        callback();
      }
    };
    return {
      ids: this.$route.query.ids,
      yhkh: "",
      list: {},
      // 添加营业执照部分
      previewImgUrl: "", //预览图片url
      previeImgVisible: false, //预览图片弹框
      dialogVisible2: false,
      form: {
        cooperativeList: "", //供应商类型
        businessScope: "", //经营范围
        companyId: "", //选择了列表则有
        mobile: "",
        userName: "", //联系人姓名
        Phone: "", //联系方式
        cardNumber: "", //银行账号
        deposit: "", //开户行
        depositNumber: "", //开户行行号
        postScript: "", //备注
        accountTitle: "", //账户名称
        businessZoneId: "",
        businessPersonId: "", //业务员id
        businessLicenseUrl: "", //营业执照url
        cooperativeName: "", //名称
        socialCreditCode: "", //统一社会信用代码
        provinceId: "", //住址省id
        provinceName: "", //住址省name
        cityId: "", //住址市id
        cityName: "", //住址市name
        areaId: "", //所在地区县id
        areaName: "", //所在地区县name
        townId: "", //住址镇乡id
        townName: "", //住址镇乡id
        villageId: "", //住址村id
        villageName: "", //住址村name
        address: "", //住所
        corName: "", //法定代表人
        registeredCapitalCh: "", //出资总额
        foundingTime: "", //成立时
        businessTerm: "", //营业期限
        businessTerm2: "", //营业期限
        directorDto: {
          directorName: "", //理事长姓名
          idCard: "", //身份证号码
          provinceId: "", //住址省id
          provinceName: "", //住址省name
          cityId: "", //住址市id
          cityName: "", //住址市name
          areaId: "", //所在地区县id
          areaName: "", //所在地区县id
          address: "", //住址
          cardPortraitUrl: "", //身份证人像url
          cardEmblemUrl: "", //身份证人像url
          headUrl: "", //头像照片url
          mobile: "", //手机号
        },
        dialogImageUrl: "", //销售/生产许可证url
        take: "", //发货地址
        checkedRegionData: [],
      },
      rules: {
        mobile: [
          { required: true, message: "请输入登录手机号", trigger: "blur" },
          { validator: valiMobilePass, trigger: "blur" },
        ],
        license: [
          {
            required: true,
            message: "营业执照不能为空",
            trigger: "change",
          },
        ],
        yyqx: [
          {
            required: true,
            message: "营业期限不能为空",
            trigger: "change",
            validator: validatorYyeqixian,
          },
        ],
        userName: [
          {
            required: true,
            message: "联系人姓名不能为空",
            trigger: "blur",
          },
        ],
        businessZoneId: [
          {
            required: true,
            message: "请选择业务区域",
            trigger: "change",
          },
        ],
        businessPersonId: [
          {
            required: true,
            message: "请选择业务负责人",
            trigger: "change",
          },
        ],
        cooperativeName: [
          {
            required: true,
            message: "供应商名称不能为空",
            trigger: "blur",
          },
        ],
        cooperativeType: [
          {
            required: true,
            message: "供应商类型不能为空",
            trigger: "change",
          },
        ],
        socialCreditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "blur",
          },
        ],
        areas: [
          {
            required: true,
            message: "所在地区不能为空",
            trigger: "change",
          },
        ],
        corName: [
          {
            required: true,
            message: "法人代表不能为空",
            trigger: "blur",
          },
        ],
        take: [
          {
            required: true,
            message: "发货地址不能为空",
            trigger: "blur",
          },
        ],
        logo: [
          {
            required: true,
            message: "企业logo不能为空",
            trigger: "change",
            validator: vallidLogo,
          },
        ],
        Phone: [
          {
            required: true,
            message: "联系方式不能为空",
            trigger: "blur",
          },
        ],

        ["directorDto.idCard"]: { validator: validateIdCard, trigger: "blur" },
        ["directorDto.mobile"]: { validator: validateMobile, trigger: "blur" },
      },
      honorFileList: [], //荣誉图片
      premisesFileList: [], //销售/生产许可证
      logoFileList: "", //销售/生产许可证
      checkedRegionData: [],
      checked: false,
      regionData,
      textarea1: "",
      textarea2: "",
      disabled: false,
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
      },
      options: [
        {
          value: "生资供应商",
          label: "生资供应商",
        },
      ],

      refArr: ["form0", "form1", "form2", "form3"],
    };
  },
  mounted() {},
  created() {
    // this.$nextTick(() => {
    this.fn();
    this.handleImgSuccess();

    // })
  },
  methods: {
    async fn() {
      let objs = {};
      await this.$http.supplierApi
        .getSupplierDetail({ id: this.ids })
        .then((res) => {
          console.log(res.data);
          this.list = res.data;
          objs = res.data;
          console.log(this.list);
          this.list.szProductsMediaList.forEach((item, index) => {
            console.log(item);
            if (item.flag == 10) {
              if (item.types == 20) {
                this.premisesFileList.push({ url: item.imgUrl });
              } else if (item.types == 30) {
                this.logoFileList = item.imgUrl;
              }
            }
          });
          // this.srcList = res.data.szProductsMediaList
          // this.srcListImages = []
          this.yhkh = res.data.szEnterpriseAccount[0];
          // this.yhkh = res.data.szProductsMediaList[0].imgUrl
          // res.data.szProductsMediaList.forEach(item => {
          //     this.srcListImages.push(item.imgUrl)

          // })
        });
      console.log(this.list);
      // this.form.businessScope = this.list.scopes
      this.$nextTick(() => {
        let that = this;
        console.log(that.list.businessTerm.split(","));

        this.form = {
          cooperativeList: that.list.orgType, //供应商类型
          businessScope: that.list.scopes, //经营范围
          companyId: "", //选择了列表则有
          mobile: "",
          userName: that.list.linkPerson, //联系人姓名
          Phone: that.list.linkPhone, //联系方式
          cardNumber: that.yhkh.accountNo, //银行账号
          deposit: that.yhkh.bankName, //开户行
          depositNumber: that.yhkh.bankNo, //开户行行号
          postScript: that.list.remark, //备注
          accountTitle: that.yhkh.accountName, //账户名称
          businessZoneId: "",
          businessPersonId: "", //业务员id
          businessLicenseUrl: that.list.szProductsMediaList[0].imgUrl, //营业执照url
          cooperativeName: that.list.enterpriseName, //名称
          socialCreditCode: that.list.orgCode, //统一社会信用代码
          address: that.list.registAddr, //住所
          corName: that.list.orgLegalPerson, //法定代表人
          registeredCapitalCh: that.list.registCapital, //出资总额
          foundingTime: that.list.registTime, //成立时
          businessTerm: that.list.businessTerm.split(","), //营业期限
          // businessTerm: that.list.businessTerm.split(','), //营业期限
          directorDto: {
            directorName: "", //理事长姓名
            idCard: "", //身份证号码
            provinceId: "", //住址省id
            provinceName: "", //住址省name
            cityId: "", //住址市id
            cityName: "", //住址市name
            areaId: "", //所在地区县id
            areaName: "", //所在地区县id
            address: "", //住址
            cardPortraitUrl: "", //身份证人像url
            cardEmblemUrl: "", //身份证人像url
            headUrl: "", //头像照片url
            mobile: "", //手机号
          },
          dialogImageUrl: "", //销售/生产许可证url
          take: that.list.addr, //发货地址
        };
        this.form.checkedRegionData = [
          Number(this.list.pid),
          Number(this.list.cid),
          Number(this.list.oid),
        ];
      });

      console.log(this.form);
    },

    //保存

    submitForm() {
      // console.log(formName);
      // this.$router.push({ path: './Success' })
      // this.$refs[formName].validate((valid) => {
      // if (valid) {
      let obj = {
        accountName: this.form.accountTitle, //账号名称
        accountNo: this.form.cardNumber, //银行账号
        addr: this.form.take, //详细地址
        bankName: this.form.deposit, //银行名称
        bankNo: this.form.depositNumber, //开户行号
        branchBank: this.form.depositNumber, //开户行支行
        businessTerm: this.form.businessTerm.join(), //营业期限
        businessUrls: this.form.businessLicenseUrl, //营业执照
        enterpriseName: this.form.cooperativeName, //企业名称
        linkPerson: this.form.userName, //联系人
        linkPhone: this.form.Phone, //联系方式
        orgCode: this.form.socialCreditCode, //信用社编码
        orgLegalPerson: this.form.corName, //企业法人
        orgType: this.form.cooperativeList, //企业类型
        registAddr: this.form.address, //注册地址
        registCapital: this.form.registeredCapitalCh, //注册资本
        registTime: this.form.foundingTime, //成立日期
        cname: this.form.cityName, //市name
        cid: this.form.cityId, //市id
        enterpriseLogo: this.logoFileList, //企业LOGO
        oid: this.form.areaId, //县id
        oname: this.form.areaName, //县name
        pid: this.form.provinceId, //省id
        pname: this.form.provinceName, //省name
        productUrls: JSON.parse(JSON.stringify(this.premisesFileList)), //生产许可证
        remark: this.form.postScript, //备注
        scopes: this.form.businessScope, //经营范围
        registStartTimie: this.form.businessTerm2, //营业期限开始
        registEndTimie: this.form.businessTerm2 ? "2099-01-01" : "", //营业期限结束
        id: this.ids,
      };
      console.log(obj);

      this.$http.supplierApi.getSupplierEdit(obj).then((res) => {
        console.log(res);
      });
      // } else {
      //     console.log('error submit!!');   //  验证不通过执行的操作
      //     return false;
      // }
      // });
    },
    checkForm() {
      const formName = ["form0", "form1", "form2", "form3"];
      this.szdqChange();

      const validates = (item) => {
        return new Promise((resolve, reject) => {
          console.log(this.$refs[item]);
          if (!this.$refs[item]) {
            resolve();
            return false;
          }
          this.$refs[item].validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject(new Error("验证不对"));
            }
          });
        });
      };
      let json = "";
      for (var i = 0; i < this.premisesFileList.length; i++) {
        json += this.premisesFileList[i].url + ",";
      }
      console.log(json);
      Promise.all(formName.map((item) => validates(item)))
        .then(() => {
          // this.submitForm()
          let obj = {
            accountName: this.form.accountTitle, //账号名称
            accountNo: this.form.cardNumber, //银行账号
            addr: this.form.take, //详细地址
            bankName: this.form.deposit, //银行名称
            bankNo: this.form.depositNumber, //开户行号
            branchBank: this.form.depositNumber, //开户行支行
            businessTerm: this.form.businessTerm.join(), //营业期限
            businessUrls: this.form.businessLicenseUrl, //营业执照
            enterpriseName: this.form.cooperativeName, //企业名称
            linkPerson: this.form.userName, //联系人
            linkPhone: this.form.Phone, //联系方式
            orgCode: this.form.socialCreditCode, //信用社编码
            orgLegalPerson: this.form.corName, //企业法人
            orgType: "生资供应商", //企业类型
            registAddr: this.form.address, //注册地址
            registCapital: this.form.registeredCapitalCh, //注册资本
            registTime: this.form.foundingTime, //成立日期
            cname: this.form.cityName, //市name
            cid: this.form.cityId, //市id
            enterpriseLogo: this.logoFileList, //企业LOGO
            oid: this.form.areaId, //县id
            oname: this.form.areaName, //县name
            pid: this.form.provinceId, //省id
            pname: this.form.provinceName, //省name
            productUrls: json, //生产许可证
            remark: this.form.postScript, //备注
            scopes: this.form.businessScope, //经营范围
            registStartTimie: "2099-01-01", //营业期限开始
            registEndTimie: "2099-01-01", //营业期限结束
            id: this.ids,
          };
          console.log(obj);

          this.$http.supplierApi.getSupplierEdit(obj).then((res) => {
            console.log(res);
            if (res.status == 1) {
              this.$router.push("./List");
              this.$message({
                message: res.message,
                type: "success",
              });
            }
          });
          console.log("成功");
        })
        .catch(() => {
          console.log("失败");
        });
    },
    gysTy(val) {
      console.log(val);
      this.$set(this.form, "cooperativeType", val);
    },
    szdqChange(val) {
      console.log(this.form.checkedRegionData);
      this.$set(this.form, "areas", this.form.checkedRegionData);
    },
    yyzzChange(val) {
      console.log(val);
      this.$set(this.form, "license", val);
    },
    timeBlur(val) {
      this.$set(this.form, "yyqx", val);
    },

    //长期

    langs(val) {
      if (this.checked) {
        console.log(this.businessTerm2);
      }
    },

    //重置

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //删除企业

    open() {
      this.$confirm("是否确认删除该企业？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          // getSupplierRem
          this.$http.supplierApi
            .getSupplierRem({ id: this.ids })
            .then((res) => {
              console.log(res);
            });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.$router.push({ path: "./List" });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //预览图片

    handlePreviewImg(file) {
      this.previewImgUrl = file.response ? file.response.url : file.url;
      this.previeImgVisible = true;
    },

    //图片上传成功

    async handleImgSuccess(file, type) {
      switch (type) {
        case "businessLicense":
          console.log(file.response);
          this.form.businessLicenseUrl = file.url;
          this.disBusinessLicense(file.url);
          break;
        case "cardPortraitUrl":
          this.form.directorDto.cardPortraitUrl = file.url;
          this.disIdcard(file.url);
          break;
        case "cardEmblemUrl":
          this.form.directorDto.cardEmblemUrl = file.url;
          break;
        case "headUrl":
          this.form.directorDto.headUrl = file.url;
          break;
        case "honor":
          this.honorFileList.push({ url: file.url, name: file.title });
          break;
        case "premises":
          this.premisesFileList.push({ url: file.url, name: file.title });
          break;
        case "logo":
          this.logoFileList = file.url;
          break;
      }
    },

    //自定义上传

    handleCustomUpload(content) {
      uploadImg(content)
        .then((res) => {
          content.onSuccess(res.data);
          this.$set(this.form, "license", val);
        })
        .catch((err) => {
          content.onError(err);
        });
    },

    //营业执照识别

    disBusinessLicense(imageUrl) {
      let LoadingInstance = this.$loading({
        target: document.getElementById("businessLicense"),
        text: "识别中...",
        background: "rgba(0,0,0,.5)",
      });
      this.$http.common
        .disBusinessLicense({ imageUrl: imageUrl })
        .then((res) => {
          console.log(res);
          LoadingInstance.close();
          let license = res.data.license;
          this.form.cooperativeName = license.name;
          this.form.socialCreditCode = license.reg_num;
          this.form.corName = license.legal_person;
          this.form.address = license.address;
          this.form.registeredCapitalCh = license.capital;
          this.form.foundingTime =
            license.start_date && license.start_date != -1
              ? license.start_date
              : "";
          this.form.businessScope = license.business;
          this.form.businessTerm = license.period;
        })
        .catch(() => {
          LoadingInstance.close();
        });
    },

    // 身份证识别

    disIdcard(imageUrl) {
      let LoadingInstance = this.$loading({
        target: document.getElementById("idCardPortrait"),
        text: "识别中...",
        background: "rgba(0,0,0,.5)",
      });
      this.$http.common
        .disIdcard({ imageUrl: imageUrl })
        .then((res) => {
          LoadingInstance.close();
          let cards = res.data.cards;
          this.form.directorDto.directorName = cards.name;
          this.form.directorDto.idCard = cards.id_num;
          this.form.directorDto.address = cards.address;
        })
        .catch(() => {
          LoadingInstance.close();
        });
    },

    // 根据地区id查询name

    handleRegionName(ids) {
      let province = this.regionData.filter((item) => item.i == ids[0])[0];
      let city = province.c.filter((item) => item.i == ids[1])[0];
      let areaName = ids[2]
        ? city.c.find((item) => item.i == ids[2])
          ? city.c.find((item) => item.i == ids[2]).n
          : ""
        : "";
      return [province.n, city.n, areaName];
    },

    //选择合作社

    selCooperative(row) {
      this.cooperativeCur = row;
      this.dialogVisible = false;
      this.form.companyId = row.id;
      this.form.mobile = row.contact_mobile;
      this.form.cooperativeName = row.company;
      this.form.socialCreditCode = row.credit_code;
      this.form.provinceId =
        row.region_id2 && row.region_id2 != "0" ? row.region_id2 : "";
      this.form.cityId =
        row.region_id3 && row.region_id3 != "0" ? row.region_id3 : "";
      this.form.areaId =
        row.region_id4 && row.region_id4 != "0" ? row.region_id4 : "";
      if (this.form.provinceId) {
        this.form.checkedRegionData = [this.form.provinceId, this.form.cityId];
        if (this.form.areaId)
          this.form.checkedRegionData.push(this.form.areaId);
      }
      console.log(this.form.areaId);

      this.form.address = row.address;
      this.form.corName = row.legal_person;
    },

    //销售/生产许可证

    handleRemoveImg(file, type) {
      switch (type) {
        case "honor":
          this.honorFileList = this.honorFileList.map(
            (item) => item.url != file.url
          );
          break;
        case "premises":
          // this.premisesFileList = this.premisesFileList.map(
          //     (item) => item.url != file.url
          // );
          this.premisesFileList.forEach((item, index) => {
            if (item.url == file.url) {
              this.premisesFileList.splice(index, 1);
            }
          });
          break;
        case "logo":
          this.logoFileList = file.url;

          break;
      }
    },
    handlePictureCardPreview(file) {
      this.form.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
  watch: {
    "form.checkedRegionData": {
      handler(newVal, oldV) {
        this.form.provinceId = newVal[0] || "";
        this.form.cityId = newVal[1] || "";
        this.form.areaId = newVal[2] || "";
        let regionNames =
          newVal.length > 0 ? this.handleRegionName(newVal) : ["", "", ""];
        this.form.provinceName = regionNames[0];
        this.form.cityName = regionNames[1];
        this.form.areaName = regionNames[2];
      },
    },
  },
};
